export default __webpack_public_path__ + "26442202a23392185d88a963ac8466e0.svg";